// Shared accent for the Propulsion Calculator tool (house blue).
export const ACCENT = "#006BCE";
